<template>
    <div class="navContainer">
        <div is="HistoryRecord"></div>
        <div is="ListNav"></div>
    </div>
</template>

<script>
    import HistoryRecord from './NavContainer/HistoryRecord.vue';
    import ListNav from './NavContainer/ListNav.vue';
    export default {
        components: {
            HistoryRecord,
            ListNav
        }
    };
</script>



// WEBPACK FOOTER //
// NavContainer.vue?5bb3f05e